<template>
    <div class="container">
        <div v-if="loadingExperts && expertIds && expertIds.length" class="row py-4">
            <div v-for="(id, index) in expertIds" :key="index" class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
                <img src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/partners/Single card of team-expert with placeholder.svg" alt="Loading">
            </div>
        </div>
        <div v-if="!loadingExperts && experten && experten.length" class="experts-tab">
            <h2 class="font-weight-bold py-4 h4">{{ $t('Partners.ourExperts') }}</h2>
            <div class="row">
                <div v-for="expert in experten" :key="expert.name" class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
                    <a v-if="expert.slug && expert.name" :href="(isDevmioNlActive || isDevMioActive) ? `/experts/${expert.slug}` : `/experten/${expert.slug}`" class="text-decoration-none mt-3">
                        <div class="card mb-4 shadow border-0 h-100 rounded-corners-10">
                            <div class="card-body text-body d-flex flex-column align-items-center justify-content-between text-center">
                                <!-- Image Section -->
                                <img v-if="expert.avatarSquareLarge.xxx" :src="expert.avatarSquareLarge.xxx" :alt="expert.name" class="img-fluid rounded-circle mb-3 partners-profile-pic"/>
                                <img v-if="!expert.avatarSquareLarge.xxx" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/partners/Placeholder PERSON image on png1.svg" alt="Expert" class="img-fluid rounded-circle mb-3 partners-profile-pic"/>
                                
                                <!-- Text Section -->
                                <!-- <div v-if="expert.name" class="text-body flex-grow-1"> -->
                                    <h6 v-if="expert.name" class="card-title mb-0 experts-partner-name text-break">{{ expert.name }}</h6>
                                <!-- </div> -->
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ExpertsTab',
        props: {
            settingsPerm: Object,
            experten: Array,
            expertIds: Array,
            loadingExperts: Boolean
        },
        data() {
            return {
                isDevMioActive: this.settingsPerm.isDevMioActive,
                isDevmioNlActive: this.settingsPerm.isDevmioNlActive,
            };              
        },
        created() {    
        },
        methods: {
            selectTab(tab) {
                this.selectedTab = tab;
            },
        }
    };
</script>

<style>
    /* mobile device*/
    @media (max-width: 767px) {
        .partners-profile-pic {
            max-width: 100px;
            max-height: 100px;
            width: 100px;
            height: 100px;
        }
    }

</style>